import { Image } from "@mantine/core";

import styles from "./page-error.module.scss";
import { Button } from "../buttons/Button/Button";

export const PageError = () => (
  <div className={styles.errorPageWrapper}>
    <div className={styles.errorPage}>
      <div className={styles.heroContainer}>
        <h1 className={styles.heading}>{"500 error"}</h1>
        <Image
          src="/images/product_illustrations/clipboard_purple.svg"
          w={205}
          h={205}
          alt="clipboard with checkbox"
        />
      </div>
      <p className={styles.errorMessage}>
        {"Something went wrong."}
        <br />
        {"We're taking a look to find a solution."}
      </p>
      <Button
        type="button"
        variant="secondary"
        size="small"
        onClick={() => window.location.reload()}
      >
        {"Try again"}
      </Button>
    </div>
  </div>
);
